// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"9d5a2efd21d1dd7ab1b0","258":"d2bdd59d871cf544c0b8"}[chunkId] + ".js");